<!--
  ~ Copyright (c) 2019 Signum+ Software & Facility GmbH
  ~ Author: jahn@signum-plus.at
  -->

<nav *ngIf="isMenuVisible" class="app-shell-menu navbar fixed-top navbar-dark bg-primary">
  <button *ngIf="!!model.sidebarModel" [kitClick]="model.toggleSidebarAction" [kitTags]="model.toggleSidebarAction.tags"
          class="app-sidebar-toggle btn btn-sm btn-outline-secondary mr-3" type="button">
    <svg>
      <use xlink:href="assets/custom-sprite.svg#ic_menu_24px"></use>
    </svg>
  </button>

  <ng-container [kitComponent]="model.viewDropdown"></ng-container>

  <div class="nav-item app-shell-menu-content">
    <ng-container *ngIf="model.menuModel" [kitComponent]="model.menuModel"></ng-container>
  </div>

  <a class="nav-item app-shell-help-link" target="_blank" href="{{helpLink}}">
    <svg>
      <use xlink:href="assets/custom-sprite.svg#help_24dp"></use>
    </svg>
  </a>

  <ng-container [kitComponent]="model.userDropdown"></ng-container>
</nav>

<div class="app-shell-sidebar">
  <ng-container [kitComponent]="model.sidebarModel"></ng-container>
</div>

<div class="app-shell-body">
  <div [kitContainer]="model.alertContainer" class="container" #alertContainer></div>
  <ng-content></ng-content>
</div>

<footer *ngIf="model.isFooterVisible" class="app-shell-footer fixed-bottom px-3">
  <div class="app-vendor">
    <a href="https://www.signum-plus.at/">
      <span class="text-muted">© <span [kitText]="model.vendorName"></span></span>
    </a>
  </div>
  <a href="/assets/2021-09-09_AGB_Teamworks.pdf" target="_blank">AGB</a>
  <a href="/privacy-declaration" target="_blank">Datenschutzerklärung</a>
  <a href="/imprint" target="_blank">Impressum</a>
  <div class="app-version">
    <span class="text-muted" [kitText]="model.version"></span>
  </div>
</footer>

<kit-backdrop [kitModel]="model.backdropModel"></kit-backdrop>
